export default "__VITE_ASSET__DamEvKNM__"